import { Breakpoints, styled } from "@vw-marketing/us-components";


export const StyledFilterPriceContainer = styled.div`
${() => `
    min-width: 100%;
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${Breakpoints.b960}px) {
        padding: 34px 25px;
        padding-bottom: 0px;
        min-width: 450px;
    }

`}
`

export const StyledFilterPriceSliderContainer = styled.div`
${() => `
    position: relative;
    display: flex;
    flex-direction: column;
    margin-top: 40px;
`}
`
